module.exports = __webpack_public_path__ + "static/media/loginimage.0a171f5f.png";